import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { slackIntegrationRepository } from '../data-access/repositories/SlackIntegrationRepository'

const base = ['slack-integration']

export const slackIntegrationQueries = {
  all: () => ({
    queryKey: buildQueryKey([...base]),
  }),
  slackUsers: (params?: {
    collection?: string
    orderBy?: string
    search?: string
    page?: number
    limit?: number | string
  }) => ({
    queryKey: buildQueryKey([...base, 'users', params]),
    queryFn: () => slackIntegrationRepository.listSlackUsers(params),
  }),
}
